import Vue from 'vue';

// The open confirmation, shown by ConfirmDialog (mounted once in app.vue).
export const confirmState = Vue.observable({ request: null, loading: false });

export const closeConfirm = () => {
  confirmState.request = null;
  confirmState.loading = false;
};

// `this.$dialog.confirm({ title, body }, { html, loader, okText, cancelText, backdropClose })`.
// Resolves with { close, loading } on OK and rejects on cancel. With `loader`, OK spins and
// the dialog stays open until the caller's close().
export const confirm = (message, options = {}) => new Promise((resolve, reject) => {
  if (confirmState.request) confirmState.request.reject();
  confirmState.loading = false;
  confirmState.request = {
    ...message,
    options,
    reject,
    resolve: () => resolve({ close: closeConfirm, loading: (on) => { confirmState.loading = on; } }),
  };
});
